/**
*
* BackButton
*
*/

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Link, useNavigate, useNavigationType } from 'react-router-dom';
import IconButton from 'components/interaction/IconButton/index.jsx';
import messages from './messages.js';

function BackButton(props) {
  const { className, size, to, variant = 'outline-secondary', ...rest } = props;
  const intl = useIntl();
  const navigationType = useNavigationType();
  const navigate = useNavigate();
  const buttonClass = classNames(['btn-icon btn-round', className]);
  const handleClick = useCallback((e) => {
    e.preventDefault();
    navigate(-1);
  }, [navigate]);

  const navProps = navigationType === 'PUSH' ? { onClick: handleClick } : { to, as: Link };

  return (
    <IconButton icon="ss-navigateleft text-primary" className={buttonClass} size={size} {...navProps} variant={variant} {...rest} aria-label={intl.formatMessage(messages.back)} />
  );
}

BackButton.propTypes = {
  to: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.string,
};

export default BackButton;
